import { api } from "./api";

// ---- Designs --------------------------------------------------------------
export async function listMyDesigns(userId) {
  const { data } = await api.get("/architect-portal/designs", {
    params: { user_id: userId },
  });
  return data;
}

export async function searchParcels(userId, q) {
  const { data } = await api.get("/architect-portal/parcel-search", {
    params: { user_id: userId, q },
  });
  return data;
}

export async function submitDesign(userId, fields) {
  const { data } = await api.post("/architect-portal/designs", {
    actor_user_id: userId,
    ...fields,
  });
  return data;
}

export async function getMyDesign(designId, userId) {
  const { data } = await api.get(
    `/architect-portal/designs/${encodeURIComponent(designId)}`,
    { params: { user_id: userId } },
  );
  return data;
}

export async function openNewVersion(designId, userId) {
  const { data } = await api.post(
    `/architect-portal/designs/${encodeURIComponent(designId)}/new-version`,
    null,
    { params: { user_id: userId } },
  );
  return data;
}

export async function updateMyDesign(designId, userId, fields, submit = false) {
  const { data } = await api.patch(
    `/architect-portal/designs/${encodeURIComponent(designId)}`,
    { actor_user_id: userId, submit, ...fields },
  );
  return data;
}

// ---- Projects -------------------------------------------------------------
export async function listMyProjects(userId) {
  const { data } = await api.get("/architect-portal/projects", {
    params: { user_id: userId },
  });
  return data;
}

export async function getProject(projectId, userId) {
  const { data } = await api.get(
    `/architect-portal/projects/${encodeURIComponent(projectId)}`,
    { params: { user_id: userId } }
  );
  return data;
}

export async function listProjectDocuments(projectId, userId) {
  const { data } = await api.get(
    `/architect-portal/projects/${encodeURIComponent(projectId)}/documents`,
    { params: { user_id: userId } }
  );
  return data;
}

export function projectDocumentPdfUrl(projectId, documentId, userId) {
  const base = api.defaults.baseURL.replace(/\/+$/, "");
  return `${base}/architect-portal/projects/${encodeURIComponent(
    projectId,
  )}/documents/${encodeURIComponent(documentId)}/pdf?user_id=${encodeURIComponent(userId)}`;
}

export async function downloadProjectDocument(projectId, documentId, userId, filename) {
  const url = projectDocumentPdfUrl(projectId, documentId, userId);
  const res = await fetch(url, { credentials: "omit" });
  if (!res.ok) throw new Error(`Download failed (${res.status})`);
  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = filename || `document-${documentId}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}

export async function logVisit(projectId, milestoneKey, userId, payload) {
  const { data } = await api.post(
    `/architect-portal/projects/${encodeURIComponent(
      projectId
    )}/milestones/${encodeURIComponent(milestoneKey)}/log-visit`,
    { actor_user_id: userId, ...payload }
  );
  return data;
}

export async function addProjectNote(projectId, userId, body, photos = []) {
  const { data } = await api.post(
    `/architect-portal/projects/${encodeURIComponent(projectId)}/notes`,
    { actor_user_id: userId, body, photos }
  );
  return data;
}

export async function sendProjectMessage(projectId, userId, body) {
  const { data } = await api.post(
    `/architect-portal/projects/${encodeURIComponent(projectId)}/messages`,
    { actor_user_id: userId, body }
  );
  return data;
}

export async function verifyMilestone(projectId, milestoneKey, userId) {
  const { data } = await api.post(
    `/architect-portal/projects/${encodeURIComponent(
      projectId
    )}/milestones/${encodeURIComponent(milestoneKey)}/verify`,
    { actor_user_id: userId }
  );
  return data;
}

export async function signSubmitDbns(projectId, userId) {
  const { data } = await api.post(
    `/architect-portal/projects/${encodeURIComponent(
      projectId
    )}/sign-submit-dbns`,
    { actor_user_id: userId }
  );
  return data;
}

export function inspectionPdfUrl(projectId, visitId, userId) {
  const base = api.defaults.baseURL.replace(/\/+$/, "");
  return `${base}/architect-portal/projects/${encodeURIComponent(
    projectId,
  )}/inspections/${encodeURIComponent(visitId)}/pdf?user_id=${encodeURIComponent(userId)}`;
}

export async function downloadInspectionPdf(projectId, visitId, userId, filename) {
  const url = inspectionPdfUrl(projectId, visitId, userId);
  const res = await fetch(url, { credentials: "omit" });
  if (!res.ok) throw new Error(`Download failed (${res.status})`);
  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = filename || `inspection-${visitId}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}

export function constructionPacketPdfUrl(projectId, userId) {
  const base = api.defaults.baseURL.replace(/\/+$/, "");
  return `${base}/architect-portal/projects/${encodeURIComponent(
    projectId,
  )}/construction-packet/pdf?user_id=${encodeURIComponent(userId)}`;
}

export async function downloadConstructionPacket(projectId, userId, filename) {
  const url = constructionPacketPdfUrl(projectId, userId);
  const res = await fetch(url, { credentials: "omit" });
  if (!res.ok) throw new Error(`Download failed (${res.status})`);
  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = filename || `construction-record-${projectId}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}
